/**
 * Maps an internal agent provider key (e.g. 'CLAUDE', 'ROVODEV') to its
 * human-readable display name.
 */
export const getAgentProviderDisplayName = (agentProvider: string): string => {
  if (agentProvider === 'CLAUDE') return 'Claude';
  if (agentProvider === '' || agentProvider === 'ROVODEV') return 'Rovo Dev';
  return 'Agent';
};
